import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { baseURL } from './baseurl';
@Injectable({
  providedIn: 'root'
})
export class AnswersService {
  username: string;
  constructor(private authService: AuthService, private http: HttpClient) { 
    this.authService.loadUserCredentials(); 
    this.username = this.authService.getUsername();
  }

  getUseranswers():Observable<any>{
    //console.log(baseURL + 'api/answers/');
    return this.http.get<any>(baseURL + 'api/answers/');    
  }

  getanswersbyQ_ID(ques_id):Observable<any>{
    //console.log(baseURL + 'api/answers/'+id);
    return this.http.get<any>(baseURL + 'api/answers/?question='+ques_id); 
  }
  getanswersbyAns_ID(ans_id):Observable<any>{
    //console.log(baseURL + 'api/answers/'+id);
    return this.http.get<any>(baseURL + 'api/answers/'+ans_id); 
  }
  getcommentsbyAns_ID(ans_id):Observable<any>{
    //console.log(baseURL + 'api/comments/'+id);
    return this.http.get<any>(baseURL + 'api/comments/?answer='+ans_id); 
  }

  getcommentsbycom_ID(com_id):Observable<any>{
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    //console.log(baseURL + 'api/comments/'+id);
    return this.http.get<any>(baseURL + 'api/comments/'+com_id, {headers}); 
  }

  postUseranswer(text, ques_id):Observable<any>{
    req: HttpRequest;
    const authToken = this.authService.getToken();
   // console.log(authToken);
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const answer = new FormData();
    answer.append("body", text);
    answer.append("question", ques_id);
    return this.http.post<any>(baseURL+'api/answers/',answer,{headers})
    .pipe(map(res => {
     // console.log(res);
      return true;
  }))
  }

  postUsercomment(text, ans_id):Observable<any>{
    req: HttpRequest;
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const comment = new FormData();
    comment.append("body", text);
    comment.append("answer", ans_id);
    return this.http.post<any>(baseURL+'api/comments/',comment,{headers})
    .pipe(map(res => {
     // console.log(res);
      return true;
  }))
  }

  answerUpvote(id):Observable<any>{
    req: HttpRequest;
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const answer = new FormData();
    answer.append("answer", id);
    return this.http.post<any>(baseURL+'api/answers/upvote-toggle/',answer,{headers})
    .pipe(map(res => {
     // console.log(res);
      return true;
  }))
  }

  commentUpvote(id):Observable<any>{
    req: HttpRequest;
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const answer = new FormData();
    answer.append("comment", id);
    return this.http.post<any>(baseURL+'api/comments/upvote-toggle/',answer,{headers})
    .pipe(map(res => {
     // console.log(res);
      return true;
  }))
  }

  deleteanswerbyID(id):Observable<any>{
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    //console.log(baseURL + 'api/questions/'+id);
    return this.http.delete<any>(baseURL + 'api/answers/'+id,{headers}).pipe(
      map(res=>{
       // console.log(res); 
        return true;
      })
    ); 
  }

  deletecommentbyID(id):Observable<any>{
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
   // console.log('comments:'+baseURL + 'api/questions/'+id);
    return this.http.delete<any>(baseURL + 'api/comments/'+id,{headers}).pipe(
      map(res=>{
       // console.log(res); 
        return true;
      })
    ); 
  }

  updateAnswer(ans_id,body){
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const answer = new FormData();
    answer.append("body", body);
    return this.http.patch<any>(baseURL + 'api/answers/'+ans_id+'/',answer,{headers}).pipe(
      map(res=>{
       // console.log(res); 
        return true;
      })
    );
  }

  updateComment(com_id,body){
    const authToken = this.authService.getToken();
    const headers = new HttpHeaders({'Authorization': 'Bearer '+ authToken});
    const comment = new FormData();
    comment.append("body", body);
    return this.http.patch<any>(baseURL + 'api/comments/'+com_id+'/',comment,{headers}).pipe(
      map(res=>{
       // console.log(res); 
        return true;
      })
    );
  }
}
